import React, { Component } from "react";

import "COMPONENTS/FullScreen/FullScreen.less";

export default class FullScreenTargetComponent extends Component {
  constructor(props) {
    super(props);
    this.isTarget = false;
    this.forceUpdateCaller = null;
  }

  renderInFullScreen = (isMain) => {
  }

  setFullScreenV2Target(isTarget) {
    this.isTarget = isTarget;
    if (!isTarget) {
      this.setForceUpdateCaller(null);
    }
  }

  isFullScreenV2Target() {
    return this.isTarget;
  }

  getMaxZIndex() {
    return 0;
  }

  setForceUpdateCaller(func) {
    this.forceUpdateCaller = func;
  }

  doFullScreenRender = () => {
    if( this.forceUpdateCaller ) this.forceUpdateCaller();
  }
}
